import Moment from "moment";
import { isPasswordStrong } from "../passwordStrength";

const NAME_REGEX = /^[A-Za-zÀ-ÖØ-öø-ÿ0-9 \-’']+$/;
const MULTIPLE_SPACES_REGEX = / {2,}/;
const DOCUMENT_REGEX = /^[A-Za-z0-9.,\-/]+$/;
const EMAIL_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+$/i;

export const validateType = ({ values, errors }) => {
  if (!values.type) {
    errors.type = "app.form.personType.error";
  }
};

export const validateName = ({ values, errors }) => {
  if (!values.name) {
    errors.name = "app.form.name.error";
    return;
  }

  const name = values.name.trim();

  if (name.length === 0) {
    errors.name = "app.form.name.invalid.minLength";
    return;
  }

  if (name.length > 100) {
    errors.name = "app.form.name.invalid.maxLength";
    return;
  }

  if (!NAME_REGEX.test(name)) {
    errors.name = "app.form.name.invalid.characters";
    return;
  }

  if (MULTIPLE_SPACES_REGEX.test(name)) {
    errors.name = "app.form.name.invalid.multipleSpaces";
    return;
  }
};

export const validateLocale = ({ values, errors }) => {
  if (!values.locale) {
    errors.locale = "app.form.locale.error";
  }
};

export const validateTaxResidence = ({ values, errors }) => {
  if (!values.taxResidence) {
    errors.taxResidence = "app.form.taxResidence.error";
  }
};

export const validateDocumentType = ({ values, errors }) => {
  if (!values.documentType) {
    errors.documentType = "app.form.documentType.error";
    return;
  }

  if (values.documentType.trim().length === 0) {
    errors.documentType = "app.form.documentType.error";
    return;
  }
};

export const validateDocumentId = ({ values, errors }) => {
  if (!values.documentId) {
    errors.documentId = "app.form.documentId.error";
    return;
  }

  const documentId = values.documentId.trim();

  if (documentId.length === 0) {
    errors.documentId = "app.documentId.invalid";
    return;
  }

  if (!DOCUMENT_REGEX.test(documentId)) {
    errors.documentId = "app.documentId.invalidCharacters";
    return;
  }
};

export const validateDateOfBirth = ({ values, errors }) => {
  if (values.type !== "NATURAL_PERSON") {
    return;
  }

  if (!values.dateOfBirth) {
    errors.dateOfBirth = "app.form.dateOfBirth.error";
    return;
  }

  const inputDate = Moment(values.dateOfBirth);
  if (!inputDate.isValid()) {
    errors.dateOfBirth = "app.form.dateOfBirth.error";
    return;
  }

  const isMinor = Moment().diff(inputDate, "years") < 18;
  if (isMinor) {
    errors.dateOfBirth = "app.form.dateOfBirth.min";
    return;
  }
};

export const validateEmail = ({ values, errors }) => {
  if (!values.email) {
    errors.email = "app.form.email.error";
    return;
  }

  if (!EMAIL_REGEX.test(values.email.trim())) {
    errors.email = "app.form.email.invalid";
    return;
  }
};

export const validateConfirmEmail = ({ values, errors }) => {
  if (!values.confirmEmail) {
    errors.confirmEmail = "app.form.confirmEmail.error";
    return;
  }

  if (values.email !== values.confirmEmail) {
    errors.confirmEmail = "app.form.confirmEmail.error.equals";
    return;
  }
};

export const validatePassword = ({ values, errors }) => {
  if (!values.password) {
    errors.password = "app.password.error";
    return;
  }

  if (values.password.length < 12) {
    errors.password = "app.password.min";
    return;
  }

  if (values.password.length > 255) {
    errors.password = "app.password.max";
    return;
  }

  if (!isPasswordStrong(values.password)) {
    errors.password = "app.password.invalid.weak";
    return;
  }

  if (!values.confirmPassword) {
    errors.confirmPassword = "app.confirmPassword.error";
    return;
  }

  if (values.password !== values.confirmPassword) {
    errors.confirmPassword = "app.confirmPassword.error.equals";
    return;
  }
};

export const validateAgentId = ({ values, errors }) => {
  if (!values.agentId) {
    errors.agentId = "app.form.agentId.error";
    return;
  }
};
